import React from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Colors, FCC } from '@zazume/zzm-base';

const Container = styled.div<any>(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${theme.spacing.s10};
    margin-bottom: ${theme.spacing.s8};
    background: ${Colors.BACKGROUND_0};
    box-shadow:
      0px 2px 3px rgba(0, 0, 0, 0.05),
      0px 0px 2px rgba(0, 0, 0, 0.2);
    border-radius: ${theme.radius.xl};

    ${theme.mq.desktop} {
      padding: ${theme.spacing.s13} ${theme.spacing.s16};
      margin-bottom: ${theme.spacing.s10};
    }
  `
);

export const Box: FCC<any> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};
